
export const ADD_GOOD = 'goods/ADD_GOOD';
export const REMOVE_GOOD = 'goods/REMOVE_GOOD';
export const LIST_GOODS = 'goods/LIST_GOODS';
export const LOAD_GOODS = 'goods/LOAD_GOODS';


export const addGood = (goodItem) => {
    return {
        type: ADD_GOOD,
        goodItem
    }
}

export const removeGood = (id) => {
    return {
        type: REMOVE_GOOD,
        id
    }
}

export const listGoods = () => {
    return {
        type: LIST_GOODS
    }
}

export const loadGoods = (goodsList) => {
    return {
        type: LOAD_GOODS,
        goodsList
    }
}


// WEBPACK FOOTER //
// ./src/actions/goods.js